/**
 * Foursome (alternate shot) team handicap allowance.
 *
 * WHS Appendix C: 50 % of the partners' combined course handicaps. Unlike the
 * scramble table there is no ordering and no positional weight — one ball
 * played alternately by two partners is a single allowance over the pair.
 *
 * Takes course handicaps, for the same reason scramble does: the 50 % IS the
 * format's allowance, so the event allowance must not be applied before it.
 *
 * A foursome is two partners, by rule. Any other roster size returns null —
 * Appendix C publishes no foursome allowance for three, and inventing one is
 * how the superseded scramble table got here (POL-74).
 */
export const FOURSOME_ALLOWANCE = 0.5;

export const getFoursomeTeamStrokes = (
  courseHandicaps: readonly number[],
): number | null =>
  courseHandicaps.length === 2
    ? Math.round((courseHandicaps[0] + courseHandicaps[1]) * FOURSOME_ALLOWANCE)
    : null;
